// ─────────────────────────────────────────────────────────────────────────
// HoyPanel.js — columna "Hoy" de Mi tablero: los 7 de la semana en filas compactas,
// las acciones cortas que solo Maxi puede resolver y lo vencido o por vencer.
// Las acciones llegan desde Tablero; acá no se llama al servidor.
// ─────────────────────────────────────────────────────────────────────────
import React from "react";
import { C, Meta, Seccion, FilaFrente } from "./componentes";
import TarjetaSemana from "./TarjetaSemana";

const HoyPanel = ({ hoy, semana, topeSemana, cortas, vencenPronto, renderPanel, abrirPanel, patch, cerrarCorta }) => (
  <div>
    <Seccion id="tab-semana" titulo={`Los 7 de esta semana (${semana.length} de ${topeSemana})`} primera>
      {semana.length === 0 && <div style={{ color: C.suave }}>No hay frentes marcados para esta semana.</div>}
      {semana.map(f => (
        <TarjetaSemana
          key={f._id}
          f={f}
          hoy={hoy}
          panel={renderPanel(f)}
          onAbrirPanel={abrirPanel}
          onCongelar={() => patch(f._id, { estado: "congelado" })}
          onSacar={() => patch(f._id, { estado: "activo" })}
        />
      ))}
    </Seccion>

    <Seccion id="tab-cortas" titulo="Solo tú, menos de 10 minutos" n={cortas.length}>
      {cortas.length === 0 && <div style={{ color: C.suave }}>Nada pendiente de este tipo.</div>}
      {cortas.map(f => (
        <div
          key={f._id}
          role="button"
          onClick={() => cerrarCorta(f)}
          style={{ display: "flex", alignItems: "center", gap: 12, background: C.caja, border: `1px solid ${C.borde}`, borderRadius: 10, padding: "10px 12px", marginBottom: 8, cursor: "pointer" }}
        >
          <span aria-hidden style={{ width: 28, height: 28, flex: "0 0 28px", borderRadius: 8, border: `2px solid ${C.verde}` }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ lineHeight: 1.3, fontSize: 15 }}>{f.titulo}</div>
            <Meta f={f} hoy={hoy} />
          </div>
        </div>
      ))}
    </Seccion>

    <Seccion id="tab-vencidos" titulo="Vencidos y por vencer (7 días)" n={vencenPronto.length}>
      {vencenPronto.length === 0 && <div style={{ color: C.suave }}>Nada vence en los próximos 7 días.</div>}
      {vencenPronto.map(f => <FilaFrente key={f._id} f={f} hoy={hoy} />)}
    </Seccion>
  </div>
);

export default HoyPanel;
